// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {  catchError } from 'rxjs/operators';
import {ConfigurationService} from './configuration-service';
import { ILanguageResult } from '../types/language';
import { API_URL } from '../shared/api';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private http: HttpClient, private configurationService: ConfigurationService) { }

  getSupportedLanguages(): Observable<ILanguageResult> {
    let url = `${this.configurationService.apiUrl}${API_URL.API_SUPPORTED_LANGUAGES}`;

    return this.http.get<ILanguageResult>(url)
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  handleError(errResponse: HttpErrorResponse | any): any {
    return throwError(errResponse.error || 'Server error');
  }
}
